import { api } from '../Services/api'
import { KEYS, readJSON, removeKey, writeJSON } from '../Utils/storage'
import { useResource } from './refData'

/* Comments: on only when the server says so (GET /config; on by default,
   DISCUSSIONS=0 in the pres repo's api/.env turns them off). Until it
   answers, and on any error, the site looks exactly as without them. */
export function useDiscussions() {
  const { data, error } = useResource('config', () => api.config(), { ttl: 10 * 60000 })
  return { enabled: data?.discussions === true, loaded: data !== undefined || Boolean(error) }
}

/* The anonymous profile a reader comments with: created on the first
   comment or report, kept in this browser. Losing it only means older
   comments no longer show "Obriši". */
let creating = null

export function commentToken() {
  return readJSON(KEYS.commentToken, null)
}

export async function ensureCommentToken({ renew = false } = {}) {
  if (renew) removeKey(KEYS.commentToken)
  const token = commentToken()
  if (token) return token
  if (!creating) {
    creating = api
      .createProfile()
      .then((value) => {
        writeJSON(KEYS.commentToken, value)
        return value
      })
      .finally(() => {
        creating = null
      })
  }
  return creating
}

/* Runs fn(token); an unknown token (profile deleted) gets one new profile. */
export async function withCommentToken(fn) {
  try {
    return await fn(await ensureCommentToken())
  } catch (error) {
    if (error?.response?.status !== 401) throw error
    return fn(await ensureCommentToken({ renew: true }))
  }
}

export const savedCommentName = () => readJSON(KEYS.commentName, '')
export const saveCommentName = (name) => writeJSON(KEYS.commentName, name)
